import React from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import Translate from 'translate';

import AsyncTable from 'components/HTMLElements/Table/AsyncTable/';
import CategoryService from 'services/CategoryService';
import DeleteModal from 'components/HTMLElements/DeleteModal';
import {toggleAlertError, toggleLoading} from 'stores/actions/';

class CategoriesList extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: [],
      deleteModalOpened: false,
    };

    this.deleteEntity = this.deleteEntity.bind( this );
    this.getData = this.getData.bind( this );
    this.toggleDeleteModal = this.toggleDeleteModal.bind( this );
  }

  deleteEntity() {
    this.props.toggleLoading( true );

    CategoryService.deleteCategory( this.entityToDelete ).then( ( response ) => {
      if( response.errors ) {
        this.props.toggleLoading( false );
        return this.props.toggleAlertError( response.errors );
      }

      this.toggleDeleteModal();
      this.getData( this.params )
    } )
  }

  getData( params ) {
    this.params = params;
    if( !this.props.isLoading ) this.props.toggleLoading( true );

    const apiParams = {
      limit: params.pageSize,
      offset: (params.page * params.pageSize),
    };
    if( params.sorted.length ) apiParams[`sortby[${params.sorted[0].id}]`] = params.sorted[0].desc ? 'DESC' : 'ASC';

    CategoryService.getCategories( apiParams ).then( ( response ) => {
      this.props.toggleLoading( false );

      if( response.data ) {
        this.setState( {
          data: response.data.data || [],
          pages: Math.ceil( response.data.total / params.pageSize ),
          total: response.data.total,
        } );
      }
    } )
  }

  toggleDeleteModal( entityId ) {
    this.entityToDelete = entityId;
    this.setState( { deleteModalOpened: !this.state.deleteModalOpened } )
  };

  render() {
    return (
      <div className="box box-default">
        <div className="box-header d-flex justify-content-between">
          <span><Translate id="categories"/></span>
          <Link to="/configurations/categories/new">
            <button className="btn btn-info"><Translate id="addCategory"/></button>
          </Link>
        </div>
        <div className="box-body">
          <AsyncTable className="app-table-white"
                      onFetchData={this.getData}
                      rowsText={<Translate id="categories"/>}
                      {...this.state}
                      columns={[
                        { Header: <Translate id="category"/>, accessor: 'category' },
                        { Header: <Translate id="externalCode"/>, accessor: 'codExt' },
                        {
                          Header: <Translate id="keys"/>, accessor: 'words', Cell: ( props ) =>
                          <span>{props.value.join( ', ' )}</span>
                        },
                        {
                          Header: <Translate id="active"/>, accessor: 'active', Cell: ( props ) =>
                          props.value ? <i className="fa fa-check"/> : <i className="fa fa-close"/>
                        },
                        {
                          Header: '', accessor: 'id',
                          maxWidth: 100,
                          Cell: props =>
                            <div>
                              <Link to={`/configurations/categories/edit/${props.value}`}>
                                <button className="btn btn-outline-info btn-sm mr-2">
                                  <i className="fa fa-edit"/>
                                </button>
                              </Link>
                              <button className="btn btn-outline-danger btn-sm"
                                      onClick={() => this.toggleDeleteModal( props.value )}>
                                <i className="fa fa-trash"/>
                              </button>
                            </div>
                        },
                      ]}
          />
        </div>

        <DeleteModal onConfirm={this.deleteEntity}
                     opened={this.state.deleteModalOpened}
                     onToggle={this.toggleDeleteModal}
        />
      </div>
    )
  }
}

const mapStateToProps = ( state ) => ({
  isLoading: state.settings.isLoading
});

const mapDispatchToProps = dispatch => ({
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( CategoriesList );



// WEBPACK FOOTER //
// ./routes/app/routes/configuration/categories/dashboard/index.js